import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

import {
    HOW_TO_ASSESS_MAZE_LINK,
    HOW_TO_ASSESS_SUMMER_LINK,
} from '../../common/navigation/navigation';

const SummerBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hideSummerBanner },
    } = bannerContext;

    const dismissHandler = () => hideSummerBanner({ classId, studentUid });

    return (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-bm-section'
        >
            <div>
                <div className='dashboard-title'>Summer Assessment</div>
                <div className='dashboard-summer-banner'>
                    During the Summer window, you should assess students using the End of Year (EOY)
                    student materials for their current grade. Student assessment materials are in
                    your DIBELS 8th Edition kit or available for download&nbsp;
                    <a
                        className='dashboard-maze-link'
                        href={HOW_TO_ASSESS_SUMMER_LINK}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        here <i className='dashboard-navigation-link-icon' />
                    </a>
                    .
                    <div className='dashboard-summer-text'>
                        Maze is required for the composite score in grades 2-6. Learn how to
                        complete Maze online or enter paper-pencil results&nbsp;
                        <a
                            href={HOW_TO_ASSESS_MAZE_LINK}
                            rel="noopener noreferrer"
                            target="_blank"
                            className='dashboard-maze-link'
                        >
                            here <i className='dashboard-navigation-link-icon' />
                        </a>
                        .
                    </div>
                </div>
            </div>
        </Banner>
    );
};

SummerBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default SummerBanner;
